/* tslint:disable */
/* eslint-disable */
/**
 * Bank API Schema
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


// May contain unused imports in some cases
// @ts-ignore
import { GetFraudLockedCardTransaction200ResponseOneOf1CardTransactionTransactionRecordListInner } from './get-fraud-locked-card-transaction200-response-one-of1-card-transaction-transaction-record-list-inner';

/**
 * 
 * @export
 * @interface GetFraudLockedCardTransaction200ResponseOneOf1CardTransaction
 */
export interface GetFraudLockedCardTransaction200ResponseOneOf1CardTransaction {
    /**
     * 
     * @type {string}
     * @memberof GetFraudLockedCardTransaction200ResponseOneOf1CardTransaction
     */
    'visaTransactionReferenceId': string;
    /**
     * 
     * @type {string}
     * @memberof GetFraudLockedCardTransaction200ResponseOneOf1CardTransaction
     */
    'paymentReferenceId': string;
    /**
     * 
     * @type {string}
     * @memberof GetFraudLockedCardTransaction200ResponseOneOf1CardTransaction
     */
    'merchantName': string;
    /**
     * 
     * @type {string}
     * @memberof GetFraudLockedCardTransaction200ResponseOneOf1CardTransaction
     */
    'merchantNameKana': string;
    /**
     * 
     * @type {string}
     * @memberof GetFraudLockedCardTransaction200ResponseOneOf1CardTransaction
     */
    'merchantNameKanji': string;
    /**
     * 
     * @type {string}
     * @memberof GetFraudLockedCardTransaction200ResponseOneOf1CardTransaction
     */
    'mergedMerchantName': string;
    /**
     * 
     * @type {number}
     * @memberof GetFraudLockedCardTransaction200ResponseOneOf1CardTransaction
     */
    'amount': number;
    /**
     * 
     * @type {number}
     * @memberof GetFraudLockedCardTransaction200ResponseOneOf1CardTransaction
     */
    'amountFx': number;
    /**
     * 
     * @type {string}
     * @memberof GetFraudLockedCardTransaction200ResponseOneOf1CardTransaction
     */
    'currencyCode': string;
    /**
     * 
     * @type {string}
     * @memberof GetFraudLockedCardTransaction200ResponseOneOf1CardTransaction
     */
    'failureReason': string;
    /**
     * 
     * @type {string}
     * @memberof GetFraudLockedCardTransaction200ResponseOneOf1CardTransaction
     */
    'processedAt': string;
    /**
     * 
     * @type {string}
     * @memberof GetFraudLockedCardTransaction200ResponseOneOf1CardTransaction
     */
    'transactionType': GetFraudLockedCardTransaction200ResponseOneOf1CardTransactionTransactionTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof GetFraudLockedCardTransaction200ResponseOneOf1CardTransaction
     */
    'transactionStatus': GetFraudLockedCardTransaction200ResponseOneOf1CardTransactionTransactionStatusEnum;
    /**
     * 
     * @type {number}
     * @memberof GetFraudLockedCardTransaction200ResponseOneOf1CardTransaction
     */
    'creditSettlement': number;
    /**
     * 
     * @type {Array<GetFraudLockedCardTransaction200ResponseOneOf1CardTransactionTransactionRecordListInner>}
     * @memberof GetFraudLockedCardTransaction200ResponseOneOf1CardTransaction
     */
    'transactionRecordList': Array<GetFraudLockedCardTransaction200ResponseOneOf1CardTransactionTransactionRecordListInner>;
}

export const GetFraudLockedCardTransaction200ResponseOneOf1CardTransactionTransactionTypeEnum = {
    confirm: 'CONFIRM',
    notConfirm: 'NOT_CONFIRM'
} as const;

export type GetFraudLockedCardTransaction200ResponseOneOf1CardTransactionTransactionTypeEnum = typeof GetFraudLockedCardTransaction200ResponseOneOf1CardTransactionTransactionTypeEnum[keyof typeof GetFraudLockedCardTransaction200ResponseOneOf1CardTransactionTransactionTypeEnum];
export const GetFraudLockedCardTransaction200ResponseOneOf1CardTransactionTransactionStatusEnum = {
    fail: 'FAIL'
} as const;

export type GetFraudLockedCardTransaction200ResponseOneOf1CardTransactionTransactionStatusEnum = typeof GetFraudLockedCardTransaction200ResponseOneOf1CardTransactionTransactionStatusEnum[keyof typeof GetFraudLockedCardTransaction200ResponseOneOf1CardTransactionTransactionStatusEnum];


